"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = exports.InstrumentationBase = void 0;
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
var instrumentation_1 = require("./instrumentation");
Object.defineProperty(exports, "InstrumentationBase", { enumerable: true, get: function () { return instrumentation_1.InstrumentationBase; } });
var normalize_1 = require("./normalize");
Object.defineProperty(exports, "normalize", { enumerable: true, get: function () { return normalize_1.normalize; } });
//# sourceMappingURL=index.js.map